import { gql } from "@apollo/client";

export const USER_STATISTICS_UPDATED = gql`
  subscription userStatisticsUpdated {
    userStatisticsUpdated {
      userId
      eventStatistics {
        id
        totalAttendedScheduledEvents
        updatedAt
        createdAt
      }
    }
  }
`;

export const USER_PERMISSIONS_UPDATED = gql`
  subscription userPermissionsUpdated {
    userPermissionsUpdated {
      userId
      kind
      badge
    }
  }
`;
